export enum sortDataList {
  LabNameDsc = 'LabNameDsc',
  LabNameAsc = 'LabNameAsc',
  CreationDateDsc = 'CreationDateDsc',
  CreationDateAsc = 'CreationDateAsc'
}
